module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/lu-b843e6436ac12254b9d23ba3fc407e37.svg";